/* eslint-disable react-hooks/exhaustive-deps */
import { Button, DatePicker, Form } from "antd";
import dayjs, { Dayjs } from "dayjs";
import { useEffect } from "react";
import DateIcon from "../../../assets/icons/DateIcon";
import SuccessModal from "../../../components/Report/SuccessModal";
import CustomModal from "../../../components/ui/CustomModal";
import { dateFormat, dbDateFormat } from "../../../constants/constants";
import { useGenerateSalaryMutation } from "../../../features/payroll/payrollApi";
import useError from "../../../hooks/useError";
import useModal from "../../../hooks/useModal";
import { toast } from "../../../lib/toast";
import { ModalComponentProps } from "../../../types";

type Props = {
  loading: boolean;
} & ModalComponentProps;

export default function GenerateSalaryModal({ handleClose, ...rest }: Props) {
  // const navigate = useNavigate();
  const [form] = Form.useForm();
  const [generateSalary, { isLoading, isError, isSuccess, error }] =
    useGenerateSalaryMutation();
  useError(isError, error, "Salary generate fail");
  const {
    handleOpen,
    open: childOpen,
    handleClose: childClose,
  } = useModal<undefined, "SUCCESS">();

  const onFinish = (values: any) => {
    const { start_date, end_date, schedule_date } = values;

    generateSalary({
      start_date: start_date?.format(dbDateFormat),
      end_date: end_date?.format(dbDateFormat),
      schedule_date: schedule_date
        ? schedule_date?.format(dbDateFormat)
        : undefined,
      task_name: "Generate Salary",
    });
  };

  useEffect(() => {
    if (isSuccess) {
      toast("success", "Salary successfully generated!");
      handleOpen({ type: "SUCCESS" });
      // if (data?.status === "success") {
      //   navigate("/admin/task-queue");
      // }
      // return handleClose();
    }
  }, [handleClose, isSuccess]);

  const start_date = Form.useWatch("start_date", form);
  const end_date = Form.useWatch("end_date", form);

  const disabledStartDate = (current: Dayjs | null): boolean => {
    if (!current) return false;
    const today = dayjs();
    const startOfPreviousMonth = today.subtract(3, "month").startOf("month");

    return (
      current.isBefore(startOfPreviousMonth, "day") ||
      current.isAfter(today, "day")
    );
  };

  const disabledEndDate = (
    current: Dayjs | null,
    startDate: Dayjs | null
  ): boolean => {
    if (!current || !startDate) return true;
    const endOfMonth = startDate.endOf("month");

    return (
      current.isBefore(startDate, "day") || current.isAfter(endOfMonth, "day")
    );
  };

  const disabledScheduleDate = (
    current: Dayjs | null,
    endDate: Dayjs | null
  ): boolean => {
    if (!current || !endDate) return true;
    const today = dayjs().startOf("day");
    const nextMonth = today.add(1, "month").endOf("day");

    return (
      current.isBefore(endDate, "day") || current.isAfter(nextMonth, "day")
    );
  };

  return (
    <CustomModal
      {...rest}
      handleClose={handleClose}
      //   width={800}
      footer={null}
      title="Generate Salary"
    >
      {childOpen?.type === "SUCCESS" && (
        <SuccessModal
          type="queue"
          open={childOpen?.open}
          handleClose={childClose}
        />
      )}
      <Form
        className="custom-form"
        layout="vertical"
        requiredMark="optional"
        size="large"
        onFinish={onFinish}
        form={form}
      >
        <Form.Item
          name="start_date"
          label="Cycle start date"
          className="mb-4"
          rules={[
            {
              required: true,
              message: "Please select cycle start date",
            },
          ]}
        >
          <DatePicker
            format={dateFormat}
            suffixIcon={<DateIcon width={18} height={20} />}
            style={{ width: "100%" }}
            size="large"
            disabledDate={disabledStartDate}
            onChange={() => {
              form.setFieldsValue({ end_date: undefined });
              form.setFieldsValue({ schedule_date: undefined });
            }}
          />
        </Form.Item>
        <Form.Item
          name="end_date"
          label="Cycle end date"
          className="mb-4"
          rules={[
            {
              required: true,
              message: "Please select cycle end date",
            },
          ]}
        >
          <DatePicker
            format={dateFormat}
            suffixIcon={<DateIcon width={18} height={20} />}
            style={{ width: "100%" }}
            size="large"
            disabledDate={(current) => disabledEndDate(current, start_date)}
            onChange={() => {
              form.setFieldsValue({ schedule_date: undefined });
            }}
          />
        </Form.Item>

        <Form.Item
          name="schedule_date"
          label="Schedule Date"
          className="mb-4"
          // rules={[
          //   {
          //     required: true,
          //     message: "Please select schedule date",
          //   },
          // ]}
        >
          <DatePicker
            format={dateFormat}
            suffixIcon={<DateIcon width={18} height={20} />}
            style={{ width: "100%" }}
            size="large"
            disabledDate={(current) => disabledScheduleDate(current, end_date)}
          />
        </Form.Item>

        <div className="flex items-center gap-4 mt-6 mb-4">
          <Button
            className="normal-dark-button modal-button"
            onClick={handleClose}
            size="middle"
          >
            Cancel
          </Button>
          <Button
            className="modal-button"
            type="primary"
            htmlType="submit"
            size="middle"
            loading={isLoading}
          >
            Generate
          </Button>
        </div>
      </Form>
    </CustomModal>
  );
}
